export const VOLUNTEERS = [
    {
        id: 0,
        first: "Jina",
        last: "Key",
        email: "demo2@demo.com",
        password: "fullstack123",
        image:"/assets/images/female1.png",
        role: "Wellness Coach",
        description: "Hello! I'm Jina. When thinking of healthcare workers, doctors and nurses immediately come to mind. I was drawn to Host a Healthcare Hero because the services are available to all healthcare workers. You don't have to be a doctor or nurse to qualify for assistance. Every member of the healthcare team, from maintenance to hospitality, has access to the same services. Everyone is appreciated! I enjoy helping all healthcare workers find his or her wellness."

    },
    {
        id: 1,
        first: "Richard",
        last: "Williams",
        email: "demo1@demo.com",
        password: "1a2b3c4d",
        image:"/assets/images/male1.png",
        role: "Logistics",
        description: "Hey, I'm Richard. I became a volunteer in March of 2020. My grandfather was part of the inaugural group of volunteers back in 2019. He always spoke of how much he enjoyed the comraderie amongst the volunteers. His tenure was cut short by the virus when he passed away in February of 2020. Host a Healthcare Hero was very kind to my family during that difficult time. It was easy for me to decide to pick up where my grandfather left off. I started donating my Operations Management skills to help with logistics and transportation. I even get out there and drive from time to time just like my grandfather did. "
    },
    {
        id: 2,
        first: "Maya",
        last: "Harris",
        email: "demo4@demo.com",
        password: "node123",
        image:"/assets/images/female2.png",
        role: "College Student",
        description: "I'm a college sophmore. The pandemic really put a damper on my first year of college. Both of my parents are healthcare professionals so they were experiencing burn out epic levels. My mom started participating in weekly group check-ins via Zoom provided by Host a Healthcare Hero. She and others like her were able to get together and talk about how they were affected by the pandemic. I really thought it was cool and meaningful. I asked about volunteering and now I volunteer as an assistant in Health & Wellness Center. I'm so glad I did."
    },
    {
        id: 3,
        first: "Mathias",
        last: "Arrington",
        email: "demo5@demo.com",
        password: "bootstrap123",
        image:"/assets/images/male4.png",
        role: "Chef",
        description: "I was forced to shutdown my restaurant in NYC. Cooking is a part of me. So, I started preparing meals for my neighbors to enjoy and I learned that many of them worked long hours at the local hospital. I thought that providing healthy meals for them and their families was the least that I could do. At the time, I did not know that my neighbor, Sophia, was the heart of Host a Healthcare Hero. She connected me with Alpha Food Services and the rest is history."
    },
    {
        id: 4,
        first: "Marlena",
        last: "Connors",
        email: "demo8@demo.com",
        password: "marathon123",
        image:"/assets/images/female4.png",
        role: "Personal Trainer",
        description: "Hi, I'm Marlie. I've been volunteering with Host a Healthcare Hero for over a year. I am a nurse and a personal trainer. Three months into the pandemic, like most of my colleagues, my mental health began to decline. A coworker told me about Host a Healthcare Hero and I began receiving assistance. Once my mental health was restored, I decided to pay it forward by donating my time. Today, it feels good to know that I am helping our heroes get into shape and feel good about theirselves."
    },
    {
        id: 5,
        first: "Norman",
        last: "Hussle",
        email: "demo9@demo.com",
        password: "syntax123",
        image:"../assets/images/male2.png",
        role: "Software Engineer",
        description: "The pandemic has really taken a toll on the workforce. Not only were people unable to work, healthcare workers were overworked. We were already providing free software and computer training to under represented communities before the pandemic, deciding to partner with Host a Healthcare Hero to extend the same service to healthcare workers was the right choice. The toll that the pandemic has taken on them is immeasurable. Providing free training will give them the option to work in other aspects of healthcare or a different career field. "
    },
    {
        id: 6,
        first: "Kenji",
        last: "Jackson",
        email: "demo9@demo.com",
        password: "javscript123",
        image:"/assets/images/female5.svg",
        role: "Yoga Instructor",
        description: "Hi, I'm Kenji. Practicing yoga & meditation helped me through law school and again when I found myself working from home at the heart of the pandemic. A family friend told me about Host a Healthcare Hero. I reach out and spoke with a Volunteer Coordinator about volunteering. I wasn't sure how I could help. But, after sharing that I am a Certified Yoga Instructor, the coordinator helped me decide to share that service. Today, I teach a few classes a week and its been wonderful to help healthcare workers get their minds and bodies in shape."
    },
    {
        id: 7,
        first: "Mario",
        last: "Rodgers",
        email: "demo3@demo.com",
        password: "react123",
        image:"/assets/images/male3.png",
        role: "Barber",
        description: "I'm Mario. When the pandemic hit, many of my clients were unable to get a haircut. I decided to provide free haircuts to my clients that were also displaced by the pandemic. It just so happend that one of my clients, at the time, was a Mission Sponsor. He shared the overall goal of Host a Healthcare Hero with me, and shortly thereafter I began volunteering. Initially, I was concerned about having a conflict of interest with the barbershop that I work at once we reopened. I spoke with my manager. Not only was he supportive, he now donates his services, too."
    }
]